var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCorner = function SvgArrowCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 29
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m188.2 19.8-7.4 7.5c-.8.8-2 1.3-3.1 1.3h-1.4c-1.2 0-2.3-.5-3.1-1.3l-7.5-7.6c-.3-.3-.3-.9 0-1.3l1.3-1.3c.3-.3.9-.3 1.3 0l5.6 5.6c.6.6 1.5.2 1.5-.6V4.6c0-.5-.4-.9-.9-.9H1.4c-.5 0-.9-.4-.9-.9V1c0-.5.4-.9.9-.9h175.1c1.2 0 2.2 1 2.2 2.2v19.8c0 .8 1 1.2 1.5.6l5.5-5.5c.3-.3.9-.3 1.3 0l1.3 1.3c.3.4.3 1-.1 1.3"
  })));
};
export default SvgArrowCorner;